import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { TextSize } from '../../models/enum';
import { LinkSublink } from '../../models/auto-generated-strapi-types/types/components/LinkSublink';

import {
  IconWrapper,
  LinkVoice,
  LinkVoiceNoA,
  LinkVoiceTextStyled,
  SubLinkVoiceTextStyled,
  SubmenuContainer,
} from './LinkActionSubmenuFls.style';

interface IProps {
  href?: string;
  text: string;
  title?: string;
  onClick?: () => void;
  onMouseOver?: (e?: any) => void;
  onMouseLeave?: (e: any, touch?: boolean) => void;
  size?: TextSize;
  type?: LinkType;
  icon?: React.ReactElement;
  iconEnd?: React.ReactElement;
  noClick?: boolean;
  isActive?: 'active' | '';
  identify?: string | number;
  hover?: any | undefined;
  exitHover?: any | undefined;
  subLinks?: LinkSublink[];
  last?: boolean;
  mobileFontSize?: number;
  fontSize?: number;
  mobileFontWeight?: number;
  fontWeight?: number;
}

export enum LinkType {
  'primary',
  'secondary',
  'header',
  'headerSecondary',
  'felsineaMobile',
}

const LinkActionSubmenuFls: React.FC<IProps> = ({
  href,
  onClick,
  size,
  type,
  text,
  title,
  icon,
  iconEnd,
  isActive,
  subLinks,
  last,
  mobileFontSize,
  fontSize,
  mobileFontWeight,
  fontWeight,
}: IProps) => {
  const router = useRouter();
  const [, setRerender] = useState<number>(0); // Trick to force re-render

  useEffect(() => {
    setRerender(Date.now());
  }, []);

  const LinkContent = (
    <>
      {icon ? <IconWrapper>{icon}</IconWrapper> : null}
      <LinkVoiceTextStyled
        type={type}
        isActive={isActive || (router.asPath === href ? 'active' : '')}
        href={href}
        mobileFontSize={mobileFontSize}
        fontSize={fontSize}
        mobileFontWeight={mobileFontWeight}
        fontWeight={fontWeight}
      >
        {text}
      </LinkVoiceTextStyled>
      {iconEnd ? <IconWrapper>{iconEnd}</IconWrapper> : null}

      <SubmenuContainer className={'link_submenu'}>
        {subLinks?.map?.((subLink: LinkSublink, index: number) => {
          return (
            <Link
              href={subLink.url as string}
              passHref
              key={`${subLink.url}_${index}_${Date.now()}`}
            >
              <LinkVoice
                onClick={onClick}
                title={title || text}
                type={LinkType.secondary}
                size={size}
                target={subLink.newTab ? '_blank' : '_self'}
                rel="noopener"
                removePaddingRight={true}
              >
                <SubLinkVoiceTextStyled
                  type={type}
                  isActive={
                    isActive || (router.asPath === subLink.url ? 'active' : '')
                  }
                  href={subLink.url as string}
                >
                  {subLink.text}
                </SubLinkVoiceTextStyled>
              </LinkVoice>
            </Link>
          );
        })}
      </SubmenuContainer>
    </>
  );

  return href ? (
    <span>
      <Link href={href as string} passHref prefetch={false}>
        <LinkVoice
          onClick={onClick}
          title={title || text}
          type={LinkType.felsineaMobile}
          size={size}
          removePaddingRight={last}
        >
          {LinkContent}
        </LinkVoice>
      </Link>
    </span>
  ) : (
    <LinkVoiceNoA
      onClick={onClick}
      title={title || text}
      type={LinkType.felsineaMobile}
      size={size}
      removePaddingRight={last}
    >
      {LinkContent}
    </LinkVoiceNoA>
  );
};

export default LinkActionSubmenuFls;
